import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { PermissionsService } from '../services/permissions.service';

@Injectable({ providedIn: 'root' })
export class MustBeMemberOfCompanyProductGuard implements CanActivate {
  private readonly permissions = inject(PermissionsService);

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const company_product_id = route.paramMap.get('company_product_id') ?? route.paramMap.get('id');
    if (!company_product_id) {
      return false;
    }

    if (
      this.permissions.isWorker() &&
      (this.permissions.isAdmin() ||
        this.permissions.isProductionTeamInCompanyProduct(company_product_id) ||
        this.permissions.isAccountManagerInCompanyProduct(company_product_id))
    ) {
      return true;
    }

    return this.permissions.isClient() || this.permissions.isPartner();
  }
}
